(function(window) {
    "use strict";
    if (typeof window.accounting == "object" && typeof window.accounting.unformat == "function") {
        var settings = window.accounting.settings;
        var unformatFunction = function(value, decimal) {
            var nativeMap = Array.prototype.map,
                nativeIsArray = Array.isArray,
                toString = Object.prototype.toString;
            var isArray = function(obj) {
                return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === "[object Array]";
            };
            var map = function(obj, iterator, context) {
                var results = [], i, j;

                if (!obj) return results;

                // Use native .map method if it exists:
                if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

                // Fallback for native .map:
                for (i = 0, j = obj.length; i < j; i++ ) {
                    results[i] = iterator.call(context, obj[i], i, obj);
                }
                return results;
            };

            if (isArray(value)) {
                return map(value, function(val) {
                    return unformatFunction(val, decimal);
                });
            }

            value = value || 0;
            if (typeof value === "number") return value;

            decimal = decimal || settings.number.decimal;

            var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]);
            var numberString = ("" + value)
                .replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
                .replace(regex, '')         // strip out any cruft
                .replace(decimal, '.');     // make sure decimal point is standard

            // Remove extra decimal symbols. Remain the last one
            while (numberString.indexOf('.') != numberString.lastIndexOf('.')) {
                numberString = numberString.substr(numberString.indexOf('.') + 1);
            }

            var unformatted = parseFloat(numberString);

            return !isNaN(unformatted) ? unformatted : 0;
        };

        window.accounting.unformat = unformatFunction;
    }
})(window);